<template>
  <dd-dialog-modal
      :title="title"
      :description="description"
      :visible="visible"
      @cancel="$emit('cancel')"
      v-bind="$attrs"
  >
    <template v-slot:buttons>
      <dd-button type="primary" outline @click="$emit('cancel')" data-dusk="create-task-cancel-button">Nee</dd-button>
      <dd-button type="primary" @click="navigateToCreateTask" data-dusk="create-task-accept-button">Ja</dd-button>
    </template>
  </dd-dialog-modal>
</template>

<script>

import AttachableApi from "~/api/attachable";
import CustomerUtils from "~/util/customer";
import CategoryEnum from "~/enums/CategoryEnum";

export default {
  name: "CreateTaskModal.vue",
  props:{
    visible:{
      type: Boolean
    },
    title:{
      type: String,
      default: 'Taak aanmaken'
    },
    description:{
      type: String,
      default: 'Wil je een nieuwe taak aanmaken?'
    },
    customerId:{
      type: [String, Number]
    },
    category:{
      type: [String, Number],
      default: 1
    },
    instanceClass:{
      type: [String, Number]
    },
    instanceId:{
      type: [String, Number]
    },
    preventRedirect:{
      type: Boolean
    }
  },
  methods:{
    navigateToCreateTask(){
      this.$emit('cancel', true);
      this.$nextTick(async () => {
        if ( this.customerId ){
          if ( this.instanceClass && this.instanceId ){
            const { data } = await AttachableApi.getByClass(this.instanceClass, this.instanceId);
            this.navigator.navigate(this.route('vue.task.createForInstance', {
              customer: this.customerId,
              category: this.category,
              instanceType: this.instanceClass,
              instanceId: this.instanceId,
              redirect: this.preventRedirect ? undefined : data.uri
            }));
          } else {
            let uri = `/customer/${this.customerId}`;
            if ( this.category === CategoryEnum.BANKING){
              uri += '/banking'
            } else {
              uri += '/overview'
            }
            this.navigator.navigate(this.route('vue.task.create', {
              customer: this.customerId,
              category: this.category,
              redirect: this.preventRedirect ? undefined : uri
            }));
          }
        } else {
            this.navigator.navigatePath('/task/create/without_customer/' + this.category, '_blank');
        }
      });
    },
  },
};
</script>
